<template>
  <v-row no-gutters>
    <v-col cols="auto" class="ai-response-bubble chat-widget" :style="`background: ${config.response_color}; color: ${config.response_text_color}`">
      <div style="width: 2rem" ref="loadingDots" />
    </v-col>
  </v-row>
</template>

<script setup>
// Import modules
import lottie from 'lottie-web'
import global_config from '@/../config.json'
import { ref, onMounted } from 'vue'

// Data
const config = ref(global_config)
const loadingDots = ref()

// Mounted
onMounted(() => {
  lottie.loadAnimation({ container: loadingDots.value, renderer: 'svg', path: 'LoadingDots.json', loop: true, autoplay: true }).setSpeed(1)
})
</script>
